import { gql } from '@apollo/client';
import { DOCUMENT_FRAGMENT } from './documentFragment';

export const W9_FRAGMENT = gql`
  fragment W9Fragment on W9 {
    id
    dba
    fein
    legalBusinessName
    legalEntity
    legalEntityDescription
    signature
    ssn
    taxClassification
    document {
      ...DocumentFragment
    }
  }
  ${DOCUMENT_FRAGMENT}
`;
